import React from 'react';
import { COR_DA_NOTA, NOTAS } from '../../nps.constants';
import { grupoDaNota } from '../../nps.utils';
import { BotaoNotaStyled, EscalaStyled, LegendasStyled, LinhaStyled } from './nps-escala.component.style';
export var NpsEscala = function (_a) {
    var nota = _a.nota, onEscolher = _a.onEscolher;
    var renderBotao = function (valor) { return (React.createElement(BotaoNotaStyled, { key: valor, type: "button", "aria-pressed": nota === valor, "aria-label": "Nota " + valor, onClick: function () { return onEscolher(valor); }, "$cor": COR_DA_NOTA[grupoDaNota(valor)], "$selecionado": nota === valor, "$apagado": nota !== null && nota !== valor }, valor)); };
    return (React.createElement("div", null,
        React.createElement(EscalaStyled, null,
            React.createElement(LinhaStyled, null, NOTAS.slice(0, 6).map(renderBotao)),
            React.createElement(LinhaStyled, null, NOTAS.slice(6).map(renderBotao))),
        React.createElement(LegendasStyled, null,
            React.createElement("span", null, "0 \u00B7 Nada prov\u00E1vel"),
            React.createElement("span", null, "Muito prov\u00E1vel \u00B7 10"))));
};
